/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWithEmailDto
 */
export interface UserWithEmailDto {
    /**
     * 
     * @type {string}
     * @memberof UserWithEmailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmailDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmailDto
     */
    email: string;
}

/**
 * Check if a given object implements the UserWithEmailDto interface.
 */
export function instanceOfUserWithEmailDto(value: object): value is UserWithEmailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserWithEmailDtoFromJSON(json: any): UserWithEmailDto {
    return UserWithEmailDtoFromJSONTyped(json, false);
}

export function UserWithEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
    };
}

export function UserWithEmailDtoToJSON(json: any): UserWithEmailDto {
    return UserWithEmailDtoToJSONTyped(json, false);
}

export function UserWithEmailDtoToJSONTyped(value?: UserWithEmailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
    };
}

